import CompanySelect from 'components/users/CompanySelect';
import Navbar from './Navbar';
import Logo from './Logo';
import UserMenu from './UserMenu';
import { NavLink } from 'react-router-dom';

const AppHeader = () => {
  return (
    <header className="container pt-4 pb-4">
      <div className="d-none d-md-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center justify-content-between">
          <NavLink to="/" className="logo">
            <Logo width="120" />
          </NavLink>

          <CompanySelect />
        </div>

        <Navbar />
        <UserMenu />
      </div>

      <div className="d-flex align-items-center justify-content-between d-md-none">
        <NavLink to="/" className="logo">
          <Logo width="100" />
        </NavLink>

        <UserMenu />
      </div>
    </header>
  );
};

export default AppHeader;
